import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class CompanyCreateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    });

    this.component.pageTemplate = this.component.props.app.templateForCompanyCreatePage;
    this.component.props.dispatch({
      type: Constants.COMPANY_CREATE_PAGE_TEMPLATE_CLEAR
    });

    let state = {};

    if (this.component.props.app.lookupSearchText) {
      state = {
        name: this.component.props.app.lookupSearchText,
        hasModifiedData: true
      };
    }

    let companyCreateDataToBeSaved: any = {};

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      companyCreateDataToBeSaved = {...this.component.props.app.savedDataBeforeRedirecting.companyCreateDataToBeSaved};

      if (!!companyCreateDataToBeSaved.counterpartyIbanForPayment) {
        companyCreateDataToBeSaved.mainBankAccountId = companyCreateDataToBeSaved.counterpartyIbanForPayment;
      }

      if (!!companyCreateDataToBeSaved.counterpartyIbanForPayment) {
        companyCreateDataToBeSaved.mainBankAccountId = companyCreateDataToBeSaved.counterpartyIbanForPayment;
      }

      if (!!companyCreateDataToBeSaved.companyBankIdForPayment) {
        companyCreateDataToBeSaved.companyBankId = companyCreateDataToBeSaved.companyBankIdForPayment;
      }
    }

    this.component.setState({
      ...companyCreateDataToBeSaved,
      ...state,
    }, () => {
      this.component.props.dispatch({
        type: Constants.LOOKUP_SEARCHTEXT_CLEAR
      });
    });
  }
}

export default new CompanyCreateWillMount();
